//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, DepartmentResponse, TeamsState, UpdateJobApplicationPayload } from './ApplicationDataTypes';
import { createAppScoreCardData, createTeamMessage, deleteMultiApplicationItems, deleteTeamMemberMessage, fetchApplicationDetailsData, fetchAppScoreCardDetailsData, fetchJobApplicationByList, fetchJobApplicationByListFilter, fetchJobApplicationByStage, fetchJobScorecardByList, fetchTeamMessagesList, updateApplicationAi, updateJobApplicationList, updateJobApplicationListForApplication, updateMultiApplication, updateTeamMessage,assignAiInterview } from '../../services/applicationService';



// Fetch job application details
export const fetchApplicationByStage = createAsyncThunk<DepartmentResponse, { baseId: number; jobId: number; filters?: any }, { rejectValue: string }>(
  'fetchApplicationByStage/fetch',
  async ({ baseId, jobId, filters = {} }, { rejectWithValue }) => {
    try {
      const response = await fetchJobApplicationByStage(baseId, jobId, filters);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);


export const fetchApplicationByListData = createAsyncThunk<
  DepartmentResponse,
  { baseId: number; jobId: number; stageId: string; page: number; limit?: number; filters?: any },
  { rejectValue: string }
>(
  'fetchApplicationByListData/fetch',
  async ({ baseId, jobId, stageId, page, limit = 25, filters = {} }, { rejectWithValue }) => {
    try {
      const response = await fetchJobApplicationByList(baseId, jobId, stageId, page, limit, filters);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);


export const fetchApplicationByListDataFilter = createAsyncThunk<
  DepartmentResponse,
  {
    baseId: number;
    jobId: number;
    stageId: string;
    page: number;
    limit?: number;
    filters?: { [key: string]: string | number };
  },
  { rejectValue: string }
>(
  'fetchApplicationByListDataFilter/fetch',
  async ({ baseId, jobId, stageId, page, limit = 25, filters = {} }, { rejectWithValue }) => {
    try {
      const response = await fetchJobApplicationByListFilter(baseId, jobId, stageId, page, limit, filters);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);

export const UpdateJobApplicationByList = createAsyncThunk<
  DepartmentResponse,
  { baseId: number; applicationId: string; stage_id: number },
  { rejectValue: string }
>(
  'UpdateJobApplicationByList/fetch',
  async ({ baseId, applicationId, stage_id }, { rejectWithValue }) => {
    try {
      const response = await updateJobApplicationList({ baseId, applicationId, stage_id });
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to update job application');
    }
  }
);



export const UpdateJobApplicationByListForApplication = createAsyncThunk<
  UpdateJobApplicationPayload,
  {
    baseId: number;
    applicationId: string;
    stage_id?: number;
    app_name?: string;
    app_headline?: string;

    app_phone_number?: string;
    app_location?: string;

    app_education?: string;
    app_work?: string;
    app_summary?: string;
    app_links?: string;
    app_cover_letter?: string;
    app_source?: string;
    app_source_by?: string;
    assign_to?: string;
    skills?: string;
    tag_id?: string;

  }, // Include app_name in the payload
  { rejectValue: string }
>(
  'UpdateJobApplicationByListForApplication/fetch',
  async ({ baseId, applicationId, stage_id, app_name,
    app_headline,
    app_location,
    app_phone_number,
    app_education,
    app_work,
    app_summary,
    app_links,
    app_cover_letter,
    app_source_by,
    assign_to,
    skills,
    tag_id

  }, { rejectWithValue }) => {
    try {
      const response = await updateJobApplicationListForApplication({
        baseId, applicationId, stage_id, app_name,
        app_headline,
        app_location,
        app_phone_number,
        app_education,
        app_work,
        app_summary,
        app_links,
        app_cover_letter,
        app_source_by,
        assign_to,
        skills,
        tag_id
      });
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to update job application');
    }
  }
);

// fetchApplicationDetailsData
export const fetchApplicationByDetails = createAsyncThunk<DepartmentResponse, { baseId: number; jobId: number; applicationId: number }, { rejectValue: string }>(
  'fetchApplicationByDetails/fetch',
  async ({ baseId, jobId, applicationId }, { rejectWithValue }) => {
    try {
      const response = await fetchApplicationDetailsData(baseId, jobId, applicationId);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);

export const createTeamMessageThunk = createAsyncThunk<DepartmentResponse, { baseId: number; formData: FormData }, { rejectValue: string }>(
  'teamMessages/create',
  async ({ baseId, formData }, { rejectWithValue }) => {
    try {
      const response = await createTeamMessage({ baseId, formData });
      return response;
    } catch (err) {
      return rejectWithValue('Failed to create team message');
    }
  }
);

export const fetchTeamMessagesListThunk = createAsyncThunk<
  TeamMessagesResponse,
  { baseId: number; jobId: string; appID: string; page: number; limit?: number; type?: string; privacy?: string; user_type?: string; status?: string },
  { rejectValue: string }
>(
  'fetchTeamMessagesList/fetch',
  async ({ baseId, jobId, appID, page, limit = 25, type, privacy, user_type, status }, { rejectWithValue }) => {
    try {
      const response = await fetchTeamMessagesList({ baseId, jobId, appID, page, limit, type, privacy, user_type, status });
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch team messages');
    }
  }
);


export const updateTeamMessageAsync = createAsyncThunk<
  DepartmentResponse,
  { baseId: number; id: number; messageContent: string },
  { rejectValue: string }
>(
  'updateTeamMessage/fetch',
  async ({ baseId, id, messageContent }, { rejectWithValue }) => {
    try {
      const response = await updateTeamMessage(baseId, id, messageContent);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to update team message');
    }
  }
);


// delete base member status action
export const deleteTeamMemberMessageData = createAsyncThunk<BaseResponse, { baseId: number, id: number }, { rejectValue: string }>(
  'base/deleteTeamMemberMessageData',
  async ({ baseId, id, }, { rejectWithValue }) => {
    try {
      const response = await deleteTeamMemberMessage(baseId, id);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to delete base member');
    }
  }
);


// score card 
export const fetchScorecardByListDataFilter = createAsyncThunk<
  DepartmentResponse,
  {
    baseId: number;
    appId: number;
    filters?: { [key: string]: string | number }; // Add filters as an optional parameter
    // scorecard_id
    scorecard_id?: number;
  },
  { rejectValue: string }
>(
  'fetchScorecardByListDataFilter/fetch',
  async ({ baseId, appId, filters = {}, scorecard_id }, { rejectWithValue }) => {
    try {
      const response = await fetchJobScorecardByList(baseId, appId, filters, scorecard_id);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);

// app score card 
export const createAppScoreCardDataThunk = createAsyncThunk<DepartmentResponse, { baseId: number, data: any }, { rejectValue: string }>(
  'createAppScoreCardDataThunk/fetch',
  async ({ baseId, data }, { rejectWithValue }) => {
    try {
      const response = await createAppScoreCardData(baseId, data);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to save scorecard data');
    }
  }
);

export const fetchAppScoreCardDetails = createAsyncThunk<DepartmentResponse, { baseId: number, appId: number }, { rejectValue: string }>(
  'fetchAppScoreCardDetails/fetch',
  async ({ baseId, appId }, { rejectWithValue }) => {
    try {
      const response = await fetchAppScoreCardDetailsData(baseId, appId);
      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);

// updateApplicationAi
export const updateApplicationAiData = createAsyncThunk<DepartmentResponse, { baseId: number; appId: number }, { rejectValue: string }>(
  'updateApplicationAiData/fetch',
  async ({ baseId, appId }, { rejectWithValue }) => {
    try {
      const response = await updateApplicationAi(baseId, appId);      
      return response;
    }
    catch (err) {      
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);

export const assignInterviewApi = createAsyncThunk<DepartmentResponse, { baseId: number; data:any }, { rejectValue: string }>(
  'assignInterviewApi/ai',
  async ({ baseId,data }, { rejectWithValue }) => {
    try {
      const response = await assignAiInterview(baseId,data);      
      return response;
    }
    catch (err) {      
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);

//deleteMultiApplicationItems

export const deleteMultiApplicationItemsData = createAsyncThunk<DepartmentResponse, { baseId: number }, { rejectValue: string }>(
  'deleteMultiApplicationItemsData/fetch',
  async ({ baseId, itemIds }: { baseId: number; itemIds: number[] }, { rejectWithValue }) => {
    try {
      const response = await deleteMultiApplicationItems(baseId, appId);      
      return response;
    }
    catch (err) {      
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);

//updateMultiApplication
export const updateMultiApplicationData = createAsyncThunk<DepartmentResponse, { baseId: number, appId: number, data: any }, { rejectValue: string }>(
  'updateMultiApplicationData/fetch',
  async ({ baseId, appId, data }, { rejectWithValue }) => {
    try {
      const response = await updateMultiApplication(baseId, appId, data);
      return response;
    }
    catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch job application');
    }
  }
);



// Initial state
const initialState: TeamsState = {
  fetchTeamsByIdStatus: 'idle',
  fetchTeamsByIdError: null,
  fetchTeamsByIdData: null,
  fetchApplicationListStatus: 'idle',
  fetchApplicationListError: null,
  fetchApplicationListData: null,
  updateApplicationListStatus: 'idle',
  updateApplicationListError: null,
  updateApplicationListData: null,
  fetchApplicationStauts: 'idle',
  fetchApplicationError: null,
  fetchApplicationData: null,
  updateApplicationListApplicationStatus: 'idle',
  updateApplicationListApplicationError: null,
  updateApplicationListApplicationData: null,
  createTeamMessageStatus: 'idle',
  createTeamMessageError: null,
  createTeamMessageData: null,
  fetchTeamMessagesStatus: 'idle',
  fetchTeamMessagesError: null,
  fetchTeamMessagesData: null,
  updateTeamMessageStatus: 'idle',
  updateTeamMessageError: null,
  updateTeamMessageData: null,
  deleteTeamMemberMessageStatus: 'idle',
  deleteTeamMemberMessageError: null,
  deleteTeamMemberMessageData: null,
  fetchApplicationListStatusFilter: 'idle',
  fetchApplicationListErrorFilter: null,
  fetchApplicationListDataFilter: null,
  // score card
  fetchScorecardByListDataFilterStatus: 'idle',
  fetchScorecardByListDataFilterError: null,
  fetchScorecardByListDataFilterData: null,
  createAppScoreCardDataStatus: 'idle',
  createAppScoreCardDataError: null,
  createAppScoreCardDataData: null,
  fetchAppScoreCardDetailsDataStatus: 'idle',
  fetchAppScoreCardDetailsDataError: null,
  fetchAppScoreCardDetailsDataData: null,
  // updateApplicationAiData
  updateApplicationAiDataStatus: 'idle',
  updateApplicationAiDataError: null,
  updateApplicationAiDataData: null,
  //deleteMultiApplicationItemsData
  deleteMultiApplicationItemsDataStatus: 'idle',
  deleteMultiApplicationItemsDataError: null,
  deleteMultiApplicationItemsDataData: null,
  //updateMultiApplication
  updateMultiApplicationDataStatus: 'idle',
  updateMultiApplicationDataError: null,
  updateMultiApplicationDataData: null


};

const ApplicationDataSlice = createSlice({
  name: 'ApplicationData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationByStage.pending, (state) => {
        state.fetchTeamsByIdStatus = 'loading';
        state.fetchTeamsByIdError = null;
      })
      .addCase(fetchApplicationByStage.fulfilled, (state, action) => {
        state.fetchTeamsByIdStatus = 'succeeded';
        state.fetchTeamsByIdData = action.payload;
        state.fetchTeamsByIdError = null;
      })
      .addCase(fetchApplicationByStage.rejected, (state, action) => {
        state.fetchTeamsByIdStatus = 'failed';
        state.fetchTeamsByIdError = action.payload || 'Failed to fetch job application';
      })
      .addCase(fetchApplicationByListData.pending, (state) => {
        state.fetchApplicationListStatus = 'loading';
        state.fetchApplicationListError = null;
      })
      .addCase(fetchApplicationByListData.fulfilled, (state, action) => {
        state.fetchApplicationListStatus = 'succeeded';
        state.fetchApplicationListData = action.payload;
        state.fetchApplicationListError = null;
      })
      .addCase(fetchApplicationByListData.rejected, (state, action) => {
        state.fetchApplicationListStatus = 'failed';
        state.fetchApplicationListError = action.payload || 'Failed to fetch job application';
      })
      .addCase(UpdateJobApplicationByList.pending, (state) => {
        state.updateApplicationListStatus = 'loading';
        state.updateApplicationListError = null;
      })
      .addCase(UpdateJobApplicationByList.fulfilled, (state, action) => {
        state.updateApplicationListStatus = 'succeeded';
        state.updateApplicationListData = action.payload;
        state.updateApplicationListError = null;
      })
      .addCase(UpdateJobApplicationByList.rejected, (state, action) => {
        state.updateApplicationListStatus = 'failed';
        state.updateApplicationListError = action.payload || 'Failed to fetch job application';
      })
      .addCase(fetchApplicationByDetails.pending, (state) => {
        state.fetchApplicationStauts = 'loading';
        state.fetchApplicationError = null;
      })
      .addCase(fetchApplicationByDetails.fulfilled, (state, action) => {
        state.fetchApplicationStauts = 'succeeded';
        state.fetchApplicationData = action.payload;
        state.fetchApplicationError = null;
      })
      .addCase(fetchApplicationByDetails.rejected, (state, action) => {
        state.fetchApplicationStauts = 'failed';
        state.fetchApplicationError = action.payload || 'Failed to fetch job application';
      })
      .addCase(UpdateJobApplicationByListForApplication.pending, (state) => {
        state.updateApplicationListApplicationStatus = 'loading';
        state.updateApplicationListApplicationError = null;
      })
      .addCase(UpdateJobApplicationByListForApplication.fulfilled, (state, action) => {
        state.updateApplicationListApplicationStatus = 'succeeded';
        state.updateApplicationListApplicationData = action.payload;
        state.updateApplicationListApplicationError = null;
      })
      .addCase(UpdateJobApplicationByListForApplication.rejected, (state, action) => {
        state.updateApplicationListApplicationStatus = 'failed';
        state.updateApplicationListApplicationError = action.payload || 'Failed to fetch job application';
      })
      .addCase(createTeamMessageThunk.pending, (state) => {
        state.createTeamMessageStatus = 'loading';
        state.createTeamMessageError = null;
      })
      .addCase(createTeamMessageThunk.fulfilled, (state, action) => {
        state.createTeamMessageStatus = 'succeeded';
        state.createTeamMessageData = action.payload;
        state.createTeamMessageError = null;
      })
      .addCase(createTeamMessageThunk.rejected, (state, action) => {
        state.createTeamMessageStatus = 'failed';
        state.createTeamMessageError = action.payload || 'Failed to create team message';
      })
      .addCase(fetchTeamMessagesListThunk.pending, (state) => {
        state.fetchTeamMessagesStatus = 'loading';
        state.fetchTeamMessagesError = null;
      })
      .addCase(fetchTeamMessagesListThunk.fulfilled, (state, action) => {
        state.fetchTeamMessagesStatus = 'succeeded';
        state.fetchTeamMessagesData = action.payload;
        state.fetchTeamMessagesError = null;
      })
      .addCase(fetchTeamMessagesListThunk.rejected, (state, action) => {
        state.fetchTeamMessagesStatus = 'failed';
        state.fetchTeamMessagesError = action.payload || 'Failed to fetch team messages';
      })
      .addCase(updateTeamMessageAsync.pending, (state) => {
        state.updateTeamMessageStatus = 'loading';
        state.updateTeamMessageError = null;
      })
      .addCase(updateTeamMessageAsync.fulfilled, (state, action) => {
        state.updateTeamMessageStatus = 'succeeded';
        state.updateTeamMessageData = action.payload;
        state.updateTeamMessageError = null;
      })
      .addCase(updateTeamMessageAsync.rejected, (state, action) => {
        state.updateTeamMessageStatus = 'failed';
        state.updateTeamMessageError = action.payload || 'Failed to update team message';
      })
      .addCase(deleteTeamMemberMessageData.pending, (state) => {
        state.deleteTeamMemberMessageStatus = 'loading';
        state.deleteTeamMemberMessageError = null;
      })
      .addCase(deleteTeamMemberMessageData.fulfilled, (state, action) => {
        state.deleteTeamMemberMessageStatus = 'succeeded';
        state.deleteTeamMemberMessageData = action.payload;
        state.deleteTeamMemberMessageError = null;
      })
      .addCase(deleteTeamMemberMessageData.rejected, (state, action) => {
        state.deleteTeamMemberMessageStatus = 'failed';
        state.deleteTeamMemberMessageError = action.payload || 'Failed to delete base member';
      })
      .addCase(fetchApplicationByListDataFilter.pending, (state) => {
        state.fetchApplicationListStatusFilter = 'loading';
        state.fetchApplicationListErrorFilter = null;
      })
      .addCase(fetchApplicationByListDataFilter.fulfilled, (state, action) => {
        state.fetchApplicationListStatusFilter = 'succeeded';
        state.fetchApplicationListDataFilter = action.payload;
        state.fetchApplicationListErrorFilter = null;
      })
      .addCase(fetchApplicationByListDataFilter.rejected, (state, action) => {
        state.fetchApplicationListStatusFilter = 'failed';
        state.fetchApplicationListErrorFilter = action.payload || 'Failed to fetch job application';
      })
      .addCase(fetchScorecardByListDataFilter.pending, (state) => {
        state.fetchScorecardByListDataFilterStatus = 'loading';
        state.fetchScorecardByListDataFilterError = null;
      })
      .addCase(fetchScorecardByListDataFilter.fulfilled, (state, action) => {
        state.fetchScorecardByListDataFilterStatus = 'succeeded';
        state.fetchScorecardByListDataFilter = action.payload;
        state.fetchScorecardByListDataFilterError = null;
      })
      .addCase(fetchScorecardByListDataFilter.rejected, (state, action) => {
        state.fetchScorecardByListDataFilterStatus = 'failed';
        state.fetchScorecardByListDataFilterError = action.payload || 'Failed to fetch job application';
      })
      .addCase(createAppScoreCardDataThunk.pending, (state) => {
        state.createAppScoreCardDataStatus = 'loading';
        state.createAppScoreCardDataError = null;
      })
      .addCase(createAppScoreCardDataThunk.fulfilled, (state, action) => {
        state.createAppScoreCardDataStatus = 'succeeded';
        state.createAppScoreCardDataData = action.payload;
        state.createAppScoreCardDataError = null;
      })
      .addCase(createAppScoreCardDataThunk.rejected, (state, action) => {
        state.createAppScoreCardDataStatus = 'failed';
        state.createAppScoreCardDataError = action.payload || 'Failed to fetch job application';
      })
      .addCase(fetchAppScoreCardDetails.pending, (state) => {
        state.fetchAppScoreCardDetailsDataStatus = 'loading';
        state.fetchAppScoreCardDetailsDataError = null;
      })
      .addCase(fetchAppScoreCardDetails.fulfilled, (state, action) => {
        state.fetchAppScoreCardDetailsDataStatus = 'succeeded';
        state.fetchAppScoreCardDetailsDataData = action.payload;
        state.fetchAppScoreCardDetailsDataError = null;
      })
      .addCase(fetchAppScoreCardDetails.rejected, (state, action) => {
        state.fetchAppScoreCardDetailsDataStatus = 'failed';
        state.fetchAppScoreCardDetailsDataError = action.payload || 'Failed to fetch job application';
      })
      .addCase(updateApplicationAiData.pending, (state) => {
        state.updateApplicationAiDataStatus = 'loading';
        state.updateApplicationAiDataError = null;
      })
      .addCase(updateApplicationAiData.fulfilled, (state, action) => {
        state.updateApplicationAiDataStatus = 'succeeded';
        state.updateApplicationAiDataData = action.payload;
        state.updateApplicationAiDataError = null;
      })
      .addCase(updateApplicationAiData.rejected, (state, action) => {
        state.updateApplicationAiDataStatus = 'failed';
        state.updateApplicationAiDataError = action.payload || 'Failed to fetch job application';
      })
      .addCase(deleteMultiApplicationItemsData.pending, (state) => {
        state.deleteMultiApplicationItemsDataStatus = 'loading';
        state.deleteMultiApplicationItemsDataError = null;
      })
      .addCase(deleteMultiApplicationItemsData.fulfilled, (state, action) => {
        state.deleteMultiApplicationItemsDataStatus = 'succeeded';
        state.deleteMultiApplicationItemsDataData = action.payload;
        state.deleteMultiApplicationItemsDataError = null;
      })
      .addCase(deleteMultiApplicationItemsData.rejected, (state, action) => {
        state.deleteMultiApplicationItemsDataStatus = 'failed';
        state.deleteMultiApplicationItemsDataError = action.payload || 'Failed to fetch job application';
      })
      .addCase(updateMultiApplicationData.pending, (state) => {
        state.updateMultiApplicationDataStatus = 'loading';
        state.updateMultiApplicationDataError = null;
      })
      .addCase(updateMultiApplicationData.fulfilled, (state, action) => {
        state.updateMultiApplicationDataStatus = 'succeeded';
        state.updateMultiApplicationDataData = action.payload;
        state.updateMultiApplicationDataError = null;
      })
      .addCase(updateMultiApplicationData.rejected, (state, action) => {
        state.updateMultiApplicationDataStatus = 'failed';
        state.updateMultiApplicationDataError = action.payload || 'Failed to fetch job application';
      });
  },
});

export default ApplicationDataSlice.reducer;
